<template>
    <div class="ServiceFrequency">
        <div class="container-fluid">
            <div class="row">
                <!--DATA TABLE-->
                <div class="col-md-6">
                    <b-container>
                        <b-row style="overflow-x:auto;">
                            <b-col cols="11">
                                <vuetable :fields="Fields"
                                          :data="FieldData"
                                          pagination-path=""
                                          :api-mode="false"
                                          class="vue-datatable"
                                          row-class="bold-first-row">

                                    <template slot="Operations" scope="props">
                                        <div class="Operations" v-if="EditMode">
                                            <DeleteIconRequest :requires-confirmation="true"
                                                               confirmation-string="Really delete this service frequency?"
                                                               endpoint="/Wraparound/ServiceFrequency/DeleteServiceFrequency"
                                                               :payload="{Id: props.rowData.Id}"
                                                               :perform-global-update="true"
                                                               :chart-id="ChartId"
                                                               v-on:success="GetServiceFrequencies()" />
                                        </div>
                                    </template>
                                </vuetable>
                            </b-col>
                            <b-col cols="1">
                                <div v-if="EditMode && CheckPermission(EditPermissionRequirement)" class="vert-icons">
                                    <b-row>
                                        <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddFrequency()" class="pointer olive-green-text" />
                                    </b-row>
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>

                <!--CHART-->
                <div class="col-md-6">
                    <b-card title="Frequency History" align="center">
                        <div style="min-height: 365px;">
                            <apexchart type="line"
                                       height="350"
                                       :options="FrequencyChart.Options"
                                       :series="ChartData" />
                        </div>
                    </b-card>
                </div>
            </div>
        </div>


        <!--MODALS-->
        <b-modal ref="add-modal" title="Add New Service Frequency Schedule" hide-footer>
            <b-container>
                <b-form @submit="AddNewFrequency">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Effective Date:</label>
                                <flat-pickr v-model="NewFrequency.EffectiveDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>FTM Frequency:</label>
                                <select class="form-control" v-model="NewFrequency.FTM" required>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiMonthly">BiMonthly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Case Carry">Case Carry</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>BHS Frequency:</label>
                                <select class="form-control" v-model="NewFrequency.BHS" required>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiMonthly">BiMonthly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Case Carry">Case Carry</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>PP Frequency:</label>
                                <select class="form-control" v-model="NewFrequency.PP" required>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiMonthly">BiMonthly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Case Carry">Case Carry</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Clinician Frequency:</label>
                                <select class="form-control" v-model="NewFrequency.Clinician" required>
                                    <option value="Weekly">Weekly</option>
                                    <option value="BiMonthly">BiMonthly</option>
                                    <option value="Monthly">Monthly</option>
                                    <option value="Case Carry">Case Carry</option>
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelAddFrequency()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import DeleteIconRequest from '../../../Core/ItemEditors/DeleteIconRequest.vue';
    import apexchart from 'vue-apexcharts';
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'ChartId',
            'EditMode'
        ],
        data: function () {
            return {
                FrequencySchema: {
                    EffectiveDate: "",
                    FTM: "",
                    PP: "",
                    BHS: "",
                    Clinician: ""
                },
                NewFrequency: {},
                FieldData: [],
                ChartData: [],
                EditMode: false,
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                },
                Fields: [
                    {
                        name: 'EffectiveDate',
                        title: "Date",
                        callback: 'formatDate|MM/DD/YY',
                    },
                    {
                        name: 'FTM',
                        title: "FTM",
                    },
                    {
                        name: 'BHS',
                        title: "BHS",
                    },
                    {
                        name: 'PP',
                        title: "PP",
                    },
                    {
                        name: 'Clinician',
                        title: "Clinician",
                    },
                    {
                        name: '__slot:Operations',
                        title: ''
                    },
                ],
                FrequencyChart: {
                    Options: {
                        chart: {
                            id: 'ServiceFrequencyChart',
                        },
                        stroke: {
                            curve: 'smooth'
                        },
                        xaxis: {
                            type: 'datetime',
                        },
                        yaxis: {
                            labels: {
                                formatter: function(val, index) {
                                    switch (val) {
                                        case 1:
                                            return "Case Carry";
                                        case 2:
                                            return "Monthly";
                                        case 3:
                                            return "BiMonthly";
                                        case 4:
                                            return "Weekly";
                                    }
                                }
                            },
                            showAlways: true
                        }
                    },
                },
            };
        },
        methods: {
            ShowAddFrequency() {
                this.NewFrequency = JSON.parse(JSON.stringify(this.FrequencySchema));
                if (this.FieldData.length > 0) {
                    this.NewFrequency.FTM = this.FieldData[0].FTM;
                    this.NewFrequency.PP = this.FieldData[0].PP;
                    this.NewFrequency.BHS = this.FieldData[0].BHS;
                    this.NewFrequency.Clinician = this.FieldData[0].Clinician;
                }
                this.$refs["add-modal"].show();
            },
            CancelAddFrequency() {
                this.$refs["add-modal"].hide();
            },
            AddNewFrequency(e) {
                e.preventDefault();
                this.NewFrequency.ClientSubProgramMembershipID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("POST", "Wraparound/ServiceFrequency/AddServiceFrequency", this.NewFrequency, this.AddNewFrequencySuccess, () => { }, true);
            },
            AddNewFrequencySuccess(response) {
                this.FieldData = response.data.data.TableData;

                //UPDATE CHART DATA
                this.ChartData = response.data.data.ChartData;
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                this.$refs["add-modal"].hide();
            },
            GetServiceFrequencies() {
                this.$MasterAPI.ExecuteRequest("GET", "Wraparound/ServiceFrequency/GetServicefrequencies", { Id: this.ChartId }, this.GetServiceFrequenciesSuccess, () => { }, false);
            },
            GetServiceFrequenciesSuccess(response) {
                this.FieldData = response.data.data.TableData;

                //UPDATE CHART DATA
                this.ChartData = response.data.data.ChartData;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            
        },
        components: {
            EditMode,
            Vuetable,
            flatPickr,
            DeleteIconRequest,
            apexchart
        },
        mounted() {
            this.GetServiceFrequencies();
        },
        computed: {
        }
    }
</script>

<style scoped>
    /deep/ tbody tr:first-child {
        font-weight: bold;
    }
</style>